<template>
  <div>
    <div class="person">
      <div class="person__avatar">
        <PolygonAvatar :image-source="person.avatarImageSource" />
      </div>
      <div class="person__details">
        <span class="person__name">{{ person.name }}</span>
        <!-- <span class="person__title">Person title</span> -->
      </div>
      <div class="person__contact">
          <a v-if="person.phone" :href="'tel:' + person.phone" class="person__contact-type" >
            <i class="icon-phone"></i>
            <span>{{ formatPhoneNumber(person.phone) }}</span>

          </a>
          <a v-if="person.email" :href="mailTo" class="person__contact-type person__contact-type--email" >
            <i class="icon-mail"></i>
            <span>{{ person.email }}</span>
          </a>
        </div>
    </div>
  </div>
</template>

<script>
// import repository from '@/core/repository/entity-repository'
import { template, formatPhoneNumber } from '@/core/formatting'

export default {
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatPhoneNumber
  },
  computed: {
    mailTo() {
      const mailSubject = template(this.$t('contact.emailTemplate'), this.currentErrand)
      return `mailto:${this.person.email}?subject=${mailSubject}`
    }
  }
}

</script>

<style lang="scss" scoped>

@media #{$mq-swapToDesktop} {
  .person__fullwidth {

    align-items: center;

    .person__details {
      padding-right: measure(xl);
    }

    .person__contact {

      flex: 1 1 auto;
      width: auto;
      margin-left: auto;
      justify-content: flex-end;

      a{
        margin-top: 0;
      }

    }
  }
}

.person {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  & + & {
    margin-top: measure(s);
    padding-top: measure(s);
    border-top: solid 1px color(light);
  }

  max-width: 100%;
  width: 100%;

}

.person__avatar {
  display: flex;
  flex-grow: 0;
  padding-right: measure(m);
}

.person__details {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 1;
  // margin-right: measure(s);
}

.person__name {
  margin-top: -3px;
  font-weight: $font-weight-medium;

  .persons & {
    font-weight: normal;
  }
}

.person__contact {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  flex-wrap: wrap;
}

.person__title {
  @include font-size(s);
  color: color(medium);
  .persons & {

  }
}
.person__contact-type--email {
    span {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
}

.person__contact-type {
  position: relative;
  display: flex;
  align-items: center;
  background-color: color(primary, 0.05);
  text-decoration: none;
  @include font-size(s);
  color: #303030;
  padding: 0.5rem 0.6875rem;
  border-radius: $border-radius-box;
  margin-right: measure(s);
  margin-top: measure(s);
  max-width: 100%;
  transition: all 300ms;

   [class^="icon"] {
     position: absolute;
     top: 50%;
     transform: translateY(-50%);
   }

  .no-touch &:hover {
    background-color: color(primary, 0.15);
  }

  &:last-child {
    margin-right: 0;
  }

  span{
    display: inline-block;
    padding-left: 1.5625rem;
    white-space: nowrap;
  }

  &:focus {
    @include focus;
  }
}

// .person__phone {
//   display: block;
//   height: 2.25rem;
//   width: 2.25rem;
//   border-radius: 50%;
//   font-size: 2.25rem;
//   line-height: 2.25rem;
//   text-decoration: none;
//   color: #00AEEF;

//   &:focus {
//     @include focus;
//   }
// }

.person__image {
  margin-right: measure(s);
}

.image-placeholder {
    width: 3rem;
    height: 3rem;
    background-size: cover;
    background-position: top center;
    border-radius: 50%;
    background-color: color(secondary-light)
}

</style>
